/* eslint-disable react/prop-types */
import ProductCard from "../SmallComponents/ProductCard";
import { useContext } from "react";
import { ShopContext } from "../Context/ShopContext";
import { useParams } from "react-router-dom";

const RelatedProducts = ({ category }) => {
  const { id } = useParams();
  const { products } = useContext(ShopContext);

  // Get related products
  const relatedProducts = products
    .filter((item) => item.category === category && item._id !== parseInt(id))
    .slice(0, 4);

  return (
    <div className="my-24">
      <div className="text-center text-3xl py-2">
        <h2 className="heading-1 playfair-display text-prime-red">
          You might also like
        </h2>
      </div>
      <div className="grid py-5  md:grid-cols-2  md:py-8 lg:grid-cols-4 lg:py-10 gap-4 gap-y-6">
        {relatedProducts.map(({ name, price, _id, images }) => (
          <ProductCard
            key={_id}
            name={name}
            price={price}
            _id={_id}
            cover={images[0]}
          />
        ))}
      </div>
    </div>
  );
};

export default RelatedProducts;
